import { render } from "./editCustomer.vue?vue&type=template&id=0bd8c6fe&scoped=true"
import script from "./editCustomer.vue?vue&type=script&lang=js"
export * from "./editCustomer.vue?vue&type=script&lang=js"

import "./editCustomer.vue?vue&type=style&index=0&id=0bd8c6fe&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd8c6fe"]])

export default __exports__